export default "__VITE_ASSET__1deee94f__"